import { BRAND } from "@/constants/brand";
import { useTheme } from "@/contexts/ThemeContext";

const Logo = ({ className = "h-10 w-auto", testId = "brand-logo" }) => {
  const { theme } = useTheme();
  const src = theme === "dark" ? BRAND.logoDark : BRAND.logoLight;

  return (
    <a
      href="#home"
      className="inline-flex items-center gap-3"
      data-testid={testId}
      aria-label="Buggu Capital home"
    >
      <img
        src={src}
        alt="Buggu Capital"
        loading="eager"
        decoding="async"
        className={`${className} object-contain transition-opacity duration-300`}
        data-testid={`${testId}-img`}
      />
    </a>
  );
};

export default Logo;
